module.exports = __webpack_public_path__ + "static/media/mbs_mood.35c10667.jpg";